import { GetLocationLookupRequest, GetLookupRequest, LocationLookup, Lookup } from "../domain";
import { Observable } from "rxjs";

export abstract class LookupsRepository {
  abstract getLookupLocations(request: GetLocationLookupRequest): Observable<LocationLookup[]>;

  abstract getLookupPlan(request: GetLookupRequest): Observable<Lookup[]>;

  abstract getLookupMasterPlan(request: GetLookupRequest): Observable<Lookup[]>;

  abstract getLookupJob(request: GetLookupRequest): Observable<Lookup[]>;
}
